import HttpCliente from "../servicios/HttpCliente";
import axios from "axios";

const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;

// invoca al axios, obtiene data del server, luego invoca al reducer. Sin dispatch no puede ingresar

export const obtenerUsuarioActual = async (dispatch, payload) => {
  return await HttpCliente.post("/Login", payload);
};

// export const obtenerPeriodoColaborador = async (idColaborador) => {
//   return await HttpCliente.get(`/Periodos/${idColaborador}`);
// };

export const obtenerPeriodoOperacion = async (idOperacion, anio) => {
  return await HttpCliente.get(`/Periodos/${idOperacion}/${anio}`);
};

/* export async function obtenerPeriodoColaborador(idColaborador) {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Periodos/${idColaborador}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.message.includes("401")) window.location = "/";
        if (error.status==401) window.location = "/";
        if (error.status==401) window.location = "/";
        console.log("error obtener resumen", error.message);
        resolve(error);
      });
  });
} */

/* 
export const obtenerUsuarioActual = async (dispatch, payload) => {
  return await new Promise((resolve, eject) => {
    HttpCliente.post("/Login", payload)
      .then((response) => {
        dispatch({
          type: "INICIAR_SESION",
          sesion: response.data,
          is_active: true,
        });

        resolve(response);
      })
      .catch((error) => {
        console.log('error iniciar sesion', error);
        
        resolve(error);
      });
  });
}; */

export const obtenerUsuarioAzure = async (dispatch, payload) => {
  return await new Promise((resolve, eject) => {
    HttpCliente.post("/Login/loginsso", payload)
      .then((response) => {
        dispatch({
          type: "INICIAR_SESION",
          sesion: response.data,
          is_active: true,
        });
        resolve(response);
      })
      .catch((error) => {
        console.log("error iniciar sesion", error);
        resolve(error);
      });
  });
};

export async function obtenerContrato(idColaborador) {
  var d = new Date(),
    year = d.getFullYear();
  const anio = year;

  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Contratos/${idColaborador}`)
      .then((response) => {
        resolve(response);
        sessionStorage.removeItem("contrato");
        window.sessionStorage.setItem(
          "contrato",
          JSON.stringify(response.data)
        );
      })
      .catch((error) => {
        errorApiContrato(error, resolve.apply, "obtenerContrato");
      });
  });
}
export async function cambiarEstadoPeriodo(payload) {
  const payloadparse = JSON.parse(payload);
  return await new Promise((resolve, eject) => {
    HttpCliente.put("/Contratos/", payloadparse)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "cambiarEstadoPeriodo");
      });
  });
}
export async function crearHistorialContrato(payload) {
  console.log(payload);
  return await new Promise((resolve, eject) => {
    HttpCliente.post("/Historiales/", payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "crearHistorialContrato");
      });
  });
}
export async function crearHistorialDetalleContrato(payload) {
  return await new Promise((resolve, eject) => {
    HttpCliente.post("/Contratos/DetalleHistorialContrato/", payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "crearHistorialDetalleContrato");
      });
  });
}

export async function obtenerHistorialContrato(idContrato, idPeriodo) {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Historiales/${idContrato}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerHistorialContrato");
      });
  });
}

export async function ObtenerContratoSeleccionado(params) {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Contratos/${params}`)
      .then((response) => {
        resolve(response);
        //console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "ObtenerContratoSeleccionado");
      });
  });
}

export const obtenerResumenHoras = async (
  idColaborador,
  idContrato,
  year,
  month
) => {
  const url = `/Horas/ResumenHoras/${idColaborador}/${idContrato}/${year}/${month}`

  return await new Promise((resolve, eject) => {
    HttpCliente.get(url)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerResumenHoras");
      });
  });
};

export async function obtenerResumenPeriodoTipo(
  idColaborador,
  idContrato,
  fecha
) {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(
      `/Horas/ResumenHorasTipos/${idColaborador}/${idContrato}/${fecha}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerResumenPeriodoTipo");
      });
  });
}

export async function enviarValidar(payload) {
  return await HttpCliente.post("Periodos/EnviarValidar", payload);
}
export async function rechazarPeriodo(payload) {
  return await HttpCliente.post("Periodos/RechazarPeriodo", payload);
}

export async function aprobarPeriodo(payload) {
  return await HttpCliente.post("Periodos/AprobarPeriodo", payload);
}

export async function obtenerTotalHrs(idColaborador, idContrato, fecha) {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Horas/TotalHoras/${idColaborador}/${idContrato}/${fecha}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerTotalHrs");
      });
  });
}
export const obtenerHora = async (idCol, idCont, year, month, day) => {
  // console.log(idContrato, year, month);
  // me trae marzo
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Horas/${idCol}/${idCont}/${year}/${month}/${day}`)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerHora");
      });
  });
};

export const obtenerTipoHoras = async () => {
  return await new Promise((resolve, eject) => {
    HttpCliente.get("/TiposHoras")
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerTipoHoras");
      });
  });
};

export const obtenerTipoHorasPorOperacion = async (idoperacion) => {
  return await new Promise((resolve, eject) => {
    HttpCliente.get("/TiposHoras/PorOperacion/" + idoperacion)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerTipoHoras");
      });
  });
};

export const obtenerActividades = async () => {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Actividades`)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerActividades");
      });
  });
};
export const obtenerUbicacionesSernageomin = async () => {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/UbicacionesSernageomin`)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerUbicacionesSernageomin");
      });
  });
};
export const obtenerubicacionFisica = async () => {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/UbicacionesFisicas`)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerubicacionFisica");
      });
  });
};
export const obtenerUnidadesOrganizacionales = async () => {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Parametros/UnidadesOrganizacionales`)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerUnidadesOrganizacionales");
      });
  });
};
export const obtenerOperaciones = async () => {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Operaciones`)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerOperaciones");
      });
  });
};
export const obtenerProyectos = async () => {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Proyectos`)
      .then((response) => {
        resolve(response);
        // console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "obtenerProyectos");
      });
  });
};

// CRUD POST
export async function registrarContrato(payload) {
  // console.log(payload);
  // const payloadparse = JSON.parse(payload);
  return await new Promise((resolve, eject) => {
    HttpCliente.post("/Horas", payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "registrarContrato");
      });
  });
}

export async function editarContrato(payload) {
  return await new Promise((resolve, eject) => {
    HttpCliente.put("/Horas", payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error);
      });
  });
}
// CRUD DELETE
export async function eliminarContrato(index) {
  console.log(index);
  return await new Promise((resolve, eject) => {
    HttpCliente.delete(`/Horas/${index}`)
      .then((response) => {
        resolve(response);
        //console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "eliminarContrato");
      });
  });
}

export async function ObtenerDetalleContrato(params) {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Contratos/DetalleColaboradoresContrato/${params}`)
      .then((response) => {
        resolve(response);
        //console.log(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "ObtenerDetalleContrato");
      });
  });
}



export const ObtenerDetalleContratopaginado = async ({
  idContrato,
  pagina,
  paginar,
  registrosPorPagina,
  criterioBusqueda,
  orderPor,
  direccion,
}) => {
  const params = {
    idContrato,
    pagina,
    paginar,
    registrosPorPagina,
    criterioBusqueda,
    orderPor,
    direccion,
  };

  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v != null && v !== '')
  );
  
  const query = new URLSearchParams(filteredParams).toString();
  
  return await HttpCliente.get(
    `/Contratos/DetalleColaboradoresContrato/?${query}`
  );
};

//Boton de descarga
export const ObtenerDetalleContratopaginadoDescargaExcel = async (contrato) => {
  return await HttpCliente.get(
    `/Contratos/ListadoColaboradoresContrato/${contrato}`
  );
};

export const DescargarExcelColaboradoresContrato = (idContrato) => {
  return HttpCliente.get(
    `/Contratos/ExportColaboradoresContrato/${idContrato}`,
    {
      responseType: "blob",
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    }
  );
};

export const ObtenerResultadosBuscador = async (idcontrato, buscar, pagina) => {
  return await HttpCliente.get(
    `/Contratos/BuscarDetalleColaboradoresContrato/${idcontrato}/${buscar}/${pagina}`
  );
};


export async function ObtenerColaboradoresContrato(params) {
  return await new Promise((resolve, eject) => {
    HttpCliente.get(`/Contratos/ColaboradoresContrato/${params}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "ObtenerColaboradoresContrato");
      });
  });
}

export const actualizarUsuario = (usuario, dispatch) => {
  return new Promise((resolve, eject) => {
    HttpCliente.put("/usuario", usuario)
      .then((response) => {
        if (response.data && response.data.imagenPerfil) {
          let fotoPerfil = response.data.imagenPerfil;
          const nuevoFile =
            "data:image/" + fotoPerfil.extension + ";base64," + fotoPerfil.data;
          response.data.imagenPerfil = nuevoFile;
        }

        dispatch({
          type: "INICIAR_SESION",
          sesion: response.data,
          autenticado: true,
        });

        resolve(response);
      })
      .catch((error) => {
        errorApi(error, resolve, "actualizarUsuario");
      });
  });
};

export const loginUsuario = (usuario, dispatch) => {
  return new Promise((resolve, eject) => {
    instancia
      .post("/usuario/login", usuario)
      .then((response) => {
        if (response.data && response.data.imagenPerfil) {
          let fotoPerfil = response.data.imagenPerfil;
          const nuevoFile =
            "data:image/" + fotoPerfil.extension + ";base64," + fotoPerfil.data;
          response.data.imagenPerfil = nuevoFile;
        }

        dispatch({
          type: "INICIAR_SESION",
          sesion: response.data,
          autenticado: true,
        });

        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

function errorApi(error, resolve, mensaje) {
  if (error.response.status === 401) {
    alert("Tu sesión expiró. Vuelva a iniciar sesión para continuar.");
    window.location = "/";
  } else if (
    error.response.status === 400 &&
    mensaje != "obtenerHistorialContrato" &&
    mensaje != "registrarContrato" &&
    (process.env.NODE_ENV != "production" || process.env.NODE_ENV != "test")
  ) {
    alert(
      "Error al " +
        mensaje +
        ": " +
        error.message +
        ", en caso de persistir el problema validar informacion con PMF y su administrador de sistema."
    );
  }

  resolve(error);
}

function errorApiContrato(error, resolve, mensaje) {
  if (error.response.status === 401) {
    alert("Tu sesión expiró. Vuelva a iniciar sesión para continuar.");
    window.location = "/";
  } else if (
    error.response.status === 400 &&
    mensaje != "obtenerHistorialContrato" &&
    mensaje != "registrarContrato" &&
    (process.env.NODE_ENV != "production" || process.env.NODE_ENV != "test")
  ) {
    alert(
      "Estimado Usuario, \n\rNo existen contratos vigentes asociados a su perfil para declarar o aprobar horas en el periodo en curso. Si necesita visualizar un contrato, debe actualizarse la fecha de término de contrato en sistema de origen o el listado de Vendor Admin / Contract Owners según corresponda."
    );
    window.location = "/";
  } else {
    alert(
      "Error al " +
        mensaje +
        ": " +
        error.message +
        ", en caso de persistir el problema validar informacion con PMF y su administrador de sistema."
    );
    window.location = "/";
  }

  resolve(error);
}

export async function actualizarReportaHorasContrato(payload) {
  return await HttpCliente.put(`Contratos/${payload.idContrato}/${payload.idColaborador}/ReportaHoras`, {
    reportaHoras: payload.reportaHoras,
  });
}

export const obtenerReporteContratos = (idColaborador) => {
  return HttpCliente.get(`/Contratos/exportar/${idColaborador}`, {
    responseType: "blob",
    headers: {
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  });
};



export const descargaContratosExcel = async (idUsuario) => {

  return HttpCliente.get(`/Contratos/${idUsuario}/descarga`,
      {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    }
    );
}